import { Component, OnInit } from '@angular/core';
// import { JhiEventManager } from 'ng-jhipster';
import { Router } from '@angular/router';
import { Item } from './';
import { ItemService } from './item.service';
import { Observable } from 'rxjs/Rx';

@Component({
    selector: 'jhi-change-passsword',
    templateUrl: './item.component.html',
    styleUrls: [
        './item.component.styl'
    ]
})
export class ItemChangePasswordComponent implements OnInit {
    item: Item;
    isSaving = false;
    userInfo: any;
    userName: string;

    constructor(
        private router: Router,
        private itemService: ItemService,
    ) {
    }

    ngOnInit() {
        this.item = new Item();
        this.userInfo = JSON.parse(sessionStorage.getItem('login'));
        this.item.userId = +sessionStorage.getItem('UserId');
    }
    
    save() {
        this.isSaving = true;
        this.subscribeToSaveResponse(this.itemService.update(this.item.userId, this.item));
    }

    private subscribeToSaveResponse(result: Observable<Item>) {
        result.subscribe((res: Item) =>
            this.onSaveSuccess(res),
            (res: Response) => this.onSaveError(res));
    }

    private onSaveSuccess(result) {
        let messageKey = result.message;
        this.isSaving = false;
        if(result.code == 1){
            this.router.navigate(['/']);
            messageKey = 'message.updateSuccess';
        }
        else if(result.code == 2007){
            messageKey = 'error.code.' + result.code;
        }
        else {
            messageKey = 'error.code.' + result.code;
        }

        setTimeout(() => {
            this.router.navigate([{ outlets: {
                notification: 'notification/' + messageKey
            }}], {
                replaceUrl: true
            });
        });
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        setTimeout(() => {
            this.router.navigate([{ outlets: {
                notification: 'notification/' + error.message
            }}], {
                replaceUrl: true
            });
        });
    }
}
